// extracted by mini-css-extract-plugin
module.exports = {"dropDown":"TablePager_dropDown__1yKVA","pager":"TablePager_pager__1o9zc"};